<template>
<div class="content">
    <div class="header">
    <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
    >
        {{item.name}}
        <div v-if="lableindex==index" class="xian"></div>
    </div>
    </div>
    <div class="metter">
        <el-table height="480" ref="JLTable" :key="tableKey" :data="voteData" border style="width:100%">
            <el-table-column min-width="160px" label="计划名称" prop="plan_name" show-overflow-tooltip></el-table-column>
            <el-table-column min-width="100px" align="center" label="量表名称" prop="topic_name" show-overflow-tooltip></el-table-column>
            <el-table-column width="100px" label="类型" align="center" prop="catedicname" show-overflow-tooltip>全面测评</el-table-column>
            <el-table-column width="90px" label="状态" align="center" prop="timestatus">
                <template slot-scope="scope">
                    <span v-if="scope.row.timestatus == 1">未开始</span>
                    <span v-else-if="scope.row.timestatus == 2">进行中</span>
                    <span v-else-if="scope.row.timestatus == 3">已结束</span>
                </template>
            </el-table-column>
            <el-table-column width="100px" label="开始时间" align="center" prop="begintime">
            <template slot-scope="scope">
                <span>{{scope.row.begintime.substring(0, 10)}}</span>
            </template>
            </el-table-column>
            <el-table-column width="100px" label="结束时间" align="center" prop="endtime">
            <template slot-scope="scope">
                <span>{{scope.row.endtime.substring(0, 10)}}</span>
            </template>
            </el-table-column>
            <el-table-column
            align="center"
            :label="'操作'"
            width="120"
            class-name="small-padding fixed-width"
            >
            <template slot-scope="scope">
                <!-- 进行中没有测评的 -->
                <el-button
                type="success"
                plain
                size="mini"
                v-if="scope.row.timestatus==2 && scope.row.submitstatus==0"
                @click="questionget(scope.row)"
                >立即测评</el-button>
                <!-- 进行中已经测评的 -->
                <el-button
                type="primary"
                plain
                size="mini"
                @click="look(scope.row)"
                v-else-if="scope.row.submitstatus==1"
                >测评报告</el-button>
                <el-button
                type="primary"
                plain
                size="mini"
                disabled
                v-else-if="scope.row.timestatus==3 && scope.row.submitstatus ==0"
                >未提交</el-button>
            </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="pagination">
    <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage2"
        layout="total, prev, pager, next"
        :total="total1"
        v-if="total1>0"
    ></el-pagination>
    </div>

    <el-dialog
    class="dialog-mini"
    title="测评问卷"
    top="5vh"
    :visible.sync="testDlogShow"
    append-to-body
    v-if="testDlogShow"
    >
        <evaluationform
        :topicId="topicId"
        :planId="planId"
        @goBack="testDlogShow=false"
        @updateList="getList"
        ></evaluationform>
    </el-dialog>

    <el-dialog
    class="dialog-mini"
    title="测评结果"
    width="1300px"
    top="5vh"
    :visible.sync="innerVisibleVideo"
    append-to-body
    v-if="innerVisibleVideo"
    >
        <report
        :topicId="topicId"
        :planId="planId"
        @close="innerVisibleVideo=false"
      ></report>
    </el-dialog>
</div>
</template>
<script>
import * as PersonCenter from '@/api/personcenter/index';
import evaluationform from './component/evaluationform.vue';
import report from './component/report.vue';
export default {
components: { evaluationform, report },
data() {
    return {
        innerVisibleVideo: false,
        tableKey: 0,
        labledata: [
            { name: '全部', id: 0 },
            { name: '未开始', id: 1 },
            { name: '进行中', id: 2 },
            { name: '已结束', id: 3 },
        ],
        currentPage2: 1,
        lableindex: 0,
        total1: 0,
        listQuery: {
            page: 1,
            limit: 8,
            userId: this.$store.state.User.ids,
            type: 0,
        },
        voteData: [],
        topicId: 0,
        planId: 0,
        testDlogShow: false,
    };
},
created() {
    this.getList();
},
methods: {
    lableArea(index, item) {
        this.listQuery.type = item.id;
        this.lableindex = index;
        this.getList();
    },
    getList() {
        PersonCenter.GetTopiccenterList(this.listQuery).then((res) => {
            this.voteData = res.data;
            this.total1 = res.count;
        });
    },
    handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
    },
    handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
    },
    look(row){
        this.topicId = row.topic_id;
        this.planId = row.plan_id;
        this.innerVisibleVideo = true;
    },
    questionget(row){
        this.topicId = row.topic_id;
        this.planId = row.plan_id;
        this.testDlogShow = true;
    },
},
};
</script>
<style scoped>
.content {
/* width: 900px; */
width: 100%;
/* height: 1000px; */
padding-bottom: 20px;
}
hr {
margin: 1px;
border-top: 1px solid #e2e3e6;
}
.heightlight {
color: #409eff !important;
}
.header {
/* width: 850px; */
height: 35px;
border-bottom: solid 1px #ccc;
padding-top: 10px;
display: flex;
}
.header > div {
width: 100px;
text-align: center;
line-height: 35px;
font-size: 16px;
cursor: pointer;
}
.header > div:hover {
color: #409eff;
}
.xian {
width: 90px;
border: solid 1px #409eff;
margin-left: 8px;
}
.metter {
/* width: 850px; */
}

.nav {
margin-top: 16px;
border-radius: 10px;
border-style: solid;
border-color: rgba(255, 255, 255, 1);
border: 1px solid #f2f2f2;
padding-top: 16px;
margin-left: 20px;
}

.navfirst {
font-weight: bold;
font-size: 16px;
border-bottom: solid 1px #f2f2f2;
padding: 0 0 10px 10px;
}
hr {
margin-top: 10px;
}
.navsecond {
border-bottom: solid 1px #f2f2f2;
padding: 10px;
}
.navsecond > div {
line-height: 30px;
color: #666;
font-size: 15px;
}
.navthirt {
padding: 10px;
text-align: right;
}
.pagination {
margin-top: 20px;
text-align: center;
}
.navsecondfelx {
flex: 1;
}
.navseconddf {
display: flex;
}
.title1deta:hover {
cursor: pointer;
text-decoration: underline;
color: #1492ff;
}
</style>